import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "store/store";

export const selectSlideClassification = createSelector(
  [
    (_, slide_id?: number) => slide_id,
    (state: RootState) => state.classifications,
  ],
  (slide_id, classifications) =>
    slide_id ? classifications[slide_id] : undefined
);

export const selectSpecimenClassification = createSelector(
  [
    (_, specimen_id?: number) => specimen_id,
    (state: RootState) => state.classifications,
    (state: RootState) => state.caseDetail,
  ],
  (specimen_id, classifications, caseDetail) => {
    if (!specimen_id) return undefined; // NOTE: is this "good code"? seems like a bit of a smell, but better than checking in every component
    return caseDetail.slides
      .filter((s) => s.specimen_id === specimen_id) // TODO: doing some work in here, it's obvious our redux store could be flatter
      .map((s) => classifications[s.id || 0])
      .filter((v) => !!v); // Creates a weird type signature `(SlideClassification | undefined)[] | undefined` when it should just be SlideClassification[] | undefined
  }
);
